/*
 This wasn't being used anywhere except the saveBlob method which I moved to
 file.helpers.ts.

 This has a reference to the xlsx package which caused a bunch of problems with
 the package.json file. So, for now this is commented out. If we need it,
 re-implement but find a different package for Excel (mabye exceljs?)

*/


import { Injectable } from '@angular/core';
import { saveToFile } from "@template-ui/helpers";

const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor() {}

  public async exportAsExcelFile(json: unknown[], excelFileName: string): Promise<void> {
    const XLSX = await import('xlsx');
    const worksheet = XLSX.utils.json_to_sheet(json);
    const workbook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveBlob(new Blob([excelBuffer]), excelFileName);
  }

  public async exportMultipleSheetsAsExcelFile(
    jsonMap: Map<string, unknown[]>,
    excelFileName: string,
  ): Promise<void> {
    const XLSX = await import('xlsx');
    const workbook = XLSX.utils.book_new();
    for (const [key, value] of jsonMap) {
      const worksheet = XLSX.utils.json_to_sheet(value);
      XLSX.utils.book_append_sheet(workbook, worksheet, key);
    }
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveBlob(new Blob([excelBuffer]), excelFileName);
  }

//   // public saveAsExcelFile(buffer: any, fileName: string): void {
//   //   const data: Blob = new Blob([buffer], {
//   //     type: EXCEL_TYPE,
//   //   });
//   //   FileSaver.saveAs(data, fileName + "_Report_" + new Date().getTime() + EXCEL_EXTENSION);
//   // }

  public saveBlob(blob: Blob, filename: string): void {

    saveToFile(blob, filename, EXCEL_EXTENSION.replace(".", ""), "{filename}_REPORT_{date}");

//     // const name = filename + "_Report_" + new Date().getTime() + EXCEL_EXTENSION
//     // const url = URL.createObjectURL(blob);
//     // const a   = document.createElement('a');
//     // a.href    = url;
//     // a.download= name;
//     // document.body.append(a);
//     // a.click();
//     // a.remove();
//     // URL.revokeObjectURL(url);
  }
}
